// IpOut.js
import React from "react";

const IpOut = () => {
  return (
    <div>
      <h1>Access Denied</h1>
      <p>Your IP address has been blocked from accessing this site.</p>
    </div>
  );
};

export default IpOut;
